import { Link } from "react-router-dom";

import {
	RedirectButton,
	RedirectWrapper,
} from './styles'

const Redirect = ({ link }) => {
	return (
		<RedirectWrapper>
			<a href={link}>
				<RedirectButton/>
			</a>
		</RedirectWrapper>
	)
}

export default Redirect;
